import { NgModule } from '@angular/core';

import { ProjetoApiService } from "./shared/projeto-api.service";
import { ProjetoService } from "./shared/projeto.service";

@NgModule({
    imports: [
    ],
    providers: [
        ProjetoApiService,
        ProjetoService
    ]
})
export class ProjetoModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/projeto/projeto.module.ts
 **/